export default __webpack_public_path__ + "static/media/wreath-corner.2de35054.png";